import React from "react";

export function PageHeader({ title, description, actions, testId }) {
  return (
    <div className="flex flex-col gap-3 pb-6 sm:flex-row sm:items-start sm:justify-between" data-testid={testId}>
      <div className="min-w-0">
        <h1 className="font-heading text-xl font-semibold text-text-main sm:text-2xl">{title}</h1>
        {description && <p className="mt-1 text-sm text-text-muted">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2 sm:flex-shrink-0">{actions}</div>}
    </div>
  );
}
